<!--页面内部header-->
<template>
  <div class="m-header">
    <i class="icon icon-arrow-left" :class="{'icon-color': iconWhite}" @click="goBack"></i>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    iconWhite: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    goBack () {
      // this.$router.go(-1);
      window.history.back()
      this.$router.isBack = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
.m-header {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 44px;
  line-height: 44px;
  z-index: 100;
  overflow: hidden;
  .icon {
    padding-left: 15px;
    font-size: 20px;
  }
}

.icon-color {
  color: #ffffff;
}
</style>
